import { Type } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentElement } from '../models/sections-model';

export class DynamicRendererComponent {

  constructor(public component: Type<any>, public data?: any) {
  }
}

export interface RendererDataInterFace {
    data:any;  
    title:string | any;
    editUpdate?:Observable<any>;  
    createUpdate?:Observable<any>;
    updateSection(section: any): void;
    preview?:boolean
}